import React, {FocusEvent} from 'react'
//@ts-ignore
import {useRouteMatch} from 'react-router-dom'
import {LoqateField} from '../loqate-field'
import {UseFormReturn} from 'react-hook-form'
import {AddressDetails} from '../../types/loqate'
import {Field} from '../field'
import {BoxProps} from '../../vanilla'

interface SearchForAddressLineFieldProps {
  form: UseFormReturn<any>
  field: Field
  inputGroupProps?: BoxProps<'div'>
  showAsterisk?: boolean
}

/* Reusable component for Address Fields on Register page, My Addresses, Delivery page.  */
export const SearchForAddressLineField = (props: SearchForAddressLineFieldProps) => {
  const {form, field, inputGroupProps = {}, showAsterisk = false} = props

  const {isExact: isRegisterPage} = useRouteMatch(['/account/register']) || {isExact: false}

  const applyAddressToForm = (address: AddressDetails) => {
    form.clearErrors([
      'searchForAddress',
      'address1',
      'address2',
      'city',
      'stateCode',
      'postalCode',
      'addressId',
      'countryCode',
    ])

    form.setValue('searchForAddress', address.PostalCode)
    form.setValue('address1', address.Line1)
    form.setValue('address2', address.Line2 ?? '')
    form.setValue('city', address.City)
    form.setValue('stateCode', address.ProvinceName)
    form.setValue('postalCode', address.PostalCode)
    form.setValue('countryCode', address.CountryIso2.toUpperCase())

    if (isRegisterPage) {
      form.setValue('addressId', address.Line1 ?? address.Line2)
    }
  }

  const handleBlurEvent = (e: FocusEvent<HTMLInputElement>) => {
    form.setValue('addressId', e.target.value)
  }

  return (
    <LoqateField
      field={field}
      onSearchValueChange={(searchValue) => form.setValue(field.name, searchValue)}
      setFoundedAddressToForm={applyAddressToForm}
      onBlur={handleBlurEvent}
      inputGroupProps={inputGroupProps}
      showAsterisk={showAsterisk}
    />
  )
}
